export const Minskiy = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [27.487399, 53.651127],
            [27.488682, 53.64875],
            [27.494208, 53.647402],
            [27.50331, 53.647209],
            [27.511111, 53.647209],
            [27.520537, 53.649136],
            [27.528989, 53.65087],
            [27.537765, 53.649714],
            [27.542316, 53.646631],
            [27.542316, 53.644511],
            [27.538415, 53.642392],
            [27.533865, 53.641428],
            [27.526063, 53.640658],
            [27.521513, 53.638538],
            [27.520863, 53.63449],
            [27.523463, 53.631792],
            [27.531264, 53.629865],
            [27.53744, 53.627551],
            [27.541016, 53.625238],
            [27.543941, 53.620997],
            [27.544062, 53.620807],
            [27.550481, 53.620843],
            [27.561091, 53.62146],
            [27.570452, 53.621953],
            [27.580646, 53.62331],
            [27.594385, 53.62666],
            [27.604543, 53.629371],
            [27.613177, 53.630877],
            [27.620796, 53.632081],
            [27.627906, 53.634792],
            [27.631461, 53.63961],
            [27.631969, 53.644427],
            [27.638572, 53.650147],
            [27.649746, 53.654964],
            [27.663967, 53.660381],
            [27.67768, 53.665798],
            [27.690885, 53.668807],
            [27.701043, 53.670011],
            [27.709677, 53.672418],
            [27.71628, 53.675728],
            [27.725422, 53.683248],
            [27.725422, 53.690166],
            [27.725422, 53.694978],
            [27.724914, 53.699789],
            [27.721359, 53.704299],
            [27.718311, 53.707606],
            [27.715772, 53.711814],
            [27.718311, 53.718728],
            [27.726438, 53.723536],
            [27.73558, 53.726241],
            [27.748277, 53.728644],
            [27.755895, 53.730447],
            [27.761482, 53.733752],
            [27.77164, 53.739761],
            [27.778694, 53.742945],
            [27.788471, 53.745283],
            [27.800329, 53.745529],
            [27.810731, 53.745283],
            [27.819052, 53.74356],
            [27.826333, 53.742576],
            [27.838399, 53.74233],
            [27.847969, 53.744298],
            [27.85421, 53.745406],
            [27.862323, 53.745529],
            [27.869812, 53.744175],
            [27.873765, 53.743683],
            [27.88167, 53.743314],
            [27.888535, 53.743314],
            [27.895193, 53.744298],
            [27.900475, 53.745027],
            [27.899947, 53.746838],
            [27.901947, 53.750892],
            [27.905661, 53.754271],
            [27.915374, 53.757142],
            [27.926802, 53.758156],
            [27.937372, 53.759676],
            [27.948514, 53.762209],
            [27.956799, 53.766431],
            [27.965084, 53.771497],
            [27.970512, 53.77825],
            [27.974798, 53.787196],
            [27.975404, 53.787185],
            [27.975655, 53.790741],
            [27.973369, 53.794791],
            [27.966798, 53.798672],
            [27.959085, 53.801709],
            [27.953085, 53.804915],
            [27.943086, 53.809301],
            [27.933944, 53.81065],
            [27.921945, 53.810988],
            [27.906803, 53.810988],
            [27.897947, 53.812337],
            [27.893947, 53.815373],
            [27.89309, 53.81959],
            [27.894519, 53.823131],
            [27.898233, 53.828022],
            [27.900804, 53.831731],
            [27.90109, 53.835946],
            [27.897376, 53.839317],
            [27.890805, 53.842183],
            [27.883663, 53.845891],
            [27.879949, 53.849599],
            [27.877949, 53.85516],
            [27.879377, 53.859204],
            [27.889948, 53.862405],
            [27.898804, 53.864596],
            [27.905788, 53.866599],
            [27.9039, 53.869332],
            [27.891884, 53.867611],
            [27.877465, 53.874291],
            [27.888279, 53.881476],
            [27.89709, 53.889353],
            [27.907677, 53.887345],
            [27.91626, 53.888457],
            [27.923126, 53.891796],
            [27.925088, 53.894909],
            [27.930516, 53.899286],
            [27.926516, 53.905177],
            [27.920231, 53.913087],
            [27.918517, 53.918976],
            [27.916803, 53.927556],
            [27.912803, 53.934116],
            [27.908803, 53.939834],
            [27.901375, 53.94387],
            [27.893662, 53.946897],
            [27.887091, 53.950091],
            [27.884805, 53.956647],
            [27.891091, 53.961018],
            [27.89709, 53.965052],
            [27.898233, 53.969421],
            [27.896519, 53.973286],
            [27.892233, 53.975638],
            [27.887662, 53.975974],
            [27.881377, 53.97631],
            [27.875092, 53.976983],
            [27.866807, 53.980847],
            [27.865093, 53.984039],
            [27.864521, 53.989246],
            [27.863093, 53.993109],
            [27.85795, 53.99714],
            [27.853094, 54.000834],
            [27.852522, 54.004528],
            [27.855379, 54.008726],
            [27.859093, 54.012083],
            [27.85795, 54.015609],
            [27.856522, 54.021148],
            [27.85795, 54.02484],
            [27.863664, 54.030378],
            [27.86795, 54.034573],
            [27.869664, 54.038264],
            [27.868807, 54.04229],
            [27.862236, 54.044471],
            [27.856522, 54.044639],
            [27.849951, 54.041619],
            [27.843095, 54.037593],
            [27.840238, 54.034573],
            [27.831096, 54.031552],
            [27.827096, 54.031049],
            [27.819954, 54.033566],
            [27.817382, 54.038096],
            [27.817382, 54.041787],
            [27.821382, 54.046484],
            [27.826239, 54.047658],
            [27.831096, 54.050845],
            [27.833095, 54.054367],
            [27.833667, 54.058559],
            [27.829953, 54.063422],
            [27.821096, 54.066943],
            [27.810812, 54.071301],
            [27.803384, 54.075157],
            [27.799098, 54.079347],
            [27.797384, 54.085213],
            [27.797718, 54.086333],
            [27.795956, 54.086218],
            [27.793956, 54.086051],
            [27.790813, 54.084878],
            [27.788813, 54.083369],
            [27.786528, 54.080856],
            [27.782814, 54.078006],
            [27.777957, 54.075995],
            [27.773386, 54.075827],
            [27.770244, 54.075995],
            [27.765101, 54.077671],
            [27.761958, 54.080688],
            [27.759959, 54.082699],
            [27.75653, 54.085045],
            [27.753388, 54.086889],
            [27.747674, 54.088397],
            [27.741674, 54.088062],
            [27.733675, 54.086721],
            [27.728818, 54.086553],
            [27.722819, 54.087056],
            [27.719391, 54.088062],
            [27.717962, 54.09024],
            [27.717676, 54.094931],
            [27.716248, 54.100292],
            [27.71282, 54.10247],
            [27.70682, 54.10314],
            [27.701392, 54.10381],
            [27.696821, 54.103643],
            [27.689679, 54.101465],
            [27.685393, 54.09912],
            [27.682537, 54.097109],
            [27.67768, 54.095099],
            [27.673394, 54.094596],
            [27.669681, 54.096942],
            [27.667681, 54.100627],
            [27.665109, 54.101465],
            [27.660824, 54.102973],
            [27.656539, 54.104815],
            [27.652539, 54.10716],
            [27.648825, 54.107663],
            [27.642254, 54.106658],
            [27.635398, 54.10649],
            [27.630255, 54.10649],
            [27.623113, 54.105653],
            [27.619113, 54.102303],
            [27.618828, 54.098952],
            [27.61997, 54.091748],
            [27.624541, 54.088062],
            [27.631684, 54.085716],
            [27.64054, 54.085548],
            [27.646254, 54.086218],
            [27.653682, 54.087224],
            [27.659681, 54.085716],
            [27.658824, 54.082699],
            [27.66111, 54.072475],
            [27.66111, 54.068116],
            [27.658824, 54.062751],
            [27.65711, 54.059397],
            [27.651682, 54.055708],
            [27.646254, 54.053696],
            [27.639683, 54.051683],
            [27.626541, 54.051851],
            [27.621113, 54.052689],
            [27.615971, 54.056547],
            [27.611685, 54.0599],
            [27.608543, 54.064092],
            [27.606543, 54.06711],
            [27.602829, 54.070128],
            [27.599115, 54.072307],
            [27.59283, 54.074486],
            [27.589402, 54.077001],
            [27.587687, 54.079682],
            [27.585116, 54.085548],
            [27.578831, 54.093256],
            [27.575688, 54.098785],
            [27.573974, 54.104145],
            [27.573974, 54.10917],
            [27.572831, 54.115869],
            [27.573117, 54.121394],
            [27.570832, 54.125748],
            [27.569118, 54.129431],
            [27.567118, 54.136293],
            [27.568832, 54.140645],
            [27.573117, 54.143155],
            [27.576831, 54.149012],
            [27.576831, 54.155704],
            [27.576545, 54.162563],
            [27.57826, 54.166075],
            [27.583402, 54.169086],
            [27.583973, 54.174437],
            [27.583116, 54.178952],
            [27.586545, 54.184135],
            [27.592544, 54.189317],
            [27.595115, 54.191992],
            [27.587973, 54.194666],
            [27.579402, 54.193997],
            [27.57226, 54.192159],
            [27.565404, 54.189986],
            [27.55769, 54.187478],
            [27.546834, 54.186642],
            [27.537406, 54.186475],
            [27.530264, 54.187646],
            [27.526264, 54.188983],
            [27.521693, 54.19149],
            [27.514551, 54.19383],
            [27.509123, 54.193997],
            [27.499695, 54.194833],
            [27.494267, 54.196839],
            [27.491981, 54.199011],
            [27.491981, 54.202354],
            [27.490267, 54.204526],
            [27.486553, 54.204526],
            [27.4785, 54.205758],
            [27.474483, 54.206541],
            [27.470465, 54.208369],
            [27.470019, 54.210196],
            [27.474036, 54.214373],
            [27.482518, 54.217505],
            [27.490999, 54.220376],
            [27.497249, 54.224552],
            [27.496802, 54.228727],
            [27.492338, 54.230293],
            [27.486535, 54.233163],
            [27.485196, 54.236294],
            [27.486982, 54.240207],
            [27.490106, 54.24412],
            [27.485642, 54.246467],
            [27.480732, 54.246467],
            [27.472697, 54.244381],
            [27.469126, 54.239424],
            [27.46734, 54.234207],
            [27.463323, 54.22951],
            [27.457073, 54.225335],
            [27.449038, 54.222203],
            [27.444128, 54.222464],
            [27.44145, 54.224813],
            [27.445467, 54.22951],
            [27.450377, 54.232902],
            [27.452609, 54.239946],
            [27.452609, 54.245424],
            [27.451717, 54.248032],
            [27.443682, 54.25064],
            [27.434754, 54.250379],
            [27.428951, 54.248815],
            [27.421362, 54.24751],
            [27.415113, 54.246467],
            [27.407805, 54.247942],
            [27.404514, 54.249651],
            [27.402768, 54.252433],
            [27.402274, 54.252288],
            [27.395703, 54.25112],
            [27.38799, 54.248616],
            [27.38399, 54.246947],
            [27.379419, 54.244777],
            [27.374848, 54.243942],
            [27.36742, 54.243942],
            [27.360849, 54.244276],
            [27.354564, 54.244109],
            [27.353993, 54.243916],
            [27.353993, 54.237598],
            [27.353421, 54.232088],
            [27.35285, 54.227078],
            [27.348279, 54.222402],
            [27.341137, 54.221232],
            [27.336851, 54.215887],
            [27.336566, 54.213381],
            [27.335994, 54.207701],
            [27.33428, 54.20369],
            [27.330852, 54.20085],
            [27.325424, 54.198844],
            [27.325709, 54.195334],
            [27.329423, 54.19149],
            [27.334851, 54.187646],
            [27.336851, 54.182965],
            [27.331423, 54.179788],
            [27.322281, 54.176444],
            [27.313139, 54.172765],
            [27.309425, 54.168584],
            [27.307979, 54.164568],
            [27.305189, 54.160893],
            [27.301004, 54.158851],
            [27.296121, 54.155992],
            [27.296121, 54.152316],
            [27.296819, 54.147005],
            [27.299609, 54.14292],
            [27.304491, 54.141286],
            [27.305189, 54.136791],
            [27.302399, 54.132705],
            [27.297516, 54.130661],
            [27.289147, 54.130253],
            [27.279382, 54.129844],
            [27.270314, 54.129026],
            [27.262642, 54.127392],
            [27.250785, 54.124939],
            [27.236835, 54.120852],
            [27.22986, 54.116764],
            [27.22707, 54.112266],
            [27.22707, 54.107769],
            [27.22707, 54.101634],
            [27.230558, 54.097136],
            [27.228465, 54.089773],
            [27.219398, 54.087318],
            [27.208936, 54.086091],
            [27.197776, 54.084863],
            [27.187314, 54.080363],
            [27.185221, 54.075452],
            [27.181734, 54.069722],
            [27.175456, 54.068904],
            [27.169, 54.068272],
            [27.168481, 54.066448],
            [27.168258, 54.059555],
            [27.170044, 54.056934],
            [27.171829, 54.054052],
            [27.172276, 54.050907],
            [27.172276, 54.046714],
            [27.173615, 54.044618],
            [27.180757, 54.045142],
            [27.183882, 54.046452],
            [27.18656, 54.046714],
            [27.191917, 54.04619],
            [27.193256, 54.041996],
            [27.192363, 54.038851],
            [27.190131, 54.034394],
            [27.190578, 54.031248],
            [27.195042, 54.02784],
            [27.197274, 54.024955],
            [27.198613, 54.018661],
            [27.198613, 54.015776],
            [27.192363, 54.010793],
            [27.182989, 54.006858],
            [27.181204, 54.00266],
            [27.174508, 53.998725],
            [27.167365, 53.997937],
            [27.158884, 53.997675],
            [27.151295, 53.999512],
            [27.142368, 53.999774],
            [27.132993, 53.998462],
            [27.128529, 53.996101],
            [27.122726, 53.993739],
            [27.114691, 53.991639],
            [27.107549, 53.988228],
            [27.103532, 53.983241],
            [27.103085, 53.977466],
            [27.105763, 53.97379],
            [27.110227, 53.969327],
            [27.112906, 53.965125],
            [27.112459, 53.960398],
            [27.108442, 53.956458],
            [27.102192, 53.952256],
            [27.095943, 53.946739],
            [27.08389, 53.942272],
            [27.072731, 53.940433],
            [27.060678, 53.939908],
            [27.050411, 53.937806],
            [27.041037, 53.931761],
            [27.037912, 53.926242],
            [27.037912, 53.922825],
            [27.033002, 53.915201],
            [27.027105, 53.911728],
            [27.027277, 53.907976],
            [27.027069, 53.904667],
            [27.027693, 53.895352],
            [27.024157, 53.891674],
            [27.022493, 53.889099],
            [27.018332, 53.885053],
            [27.016876, 53.882846],
            [27.016252, 53.880271],
            [27.019996, 53.878677],
            [27.024365, 53.879535],
            [27.031022, 53.88162],
            [27.036639, 53.883459],
            [27.04184, 53.885176],
            [27.046416, 53.886157],
            [27.049121, 53.886402],
            [27.05557, 53.88726],
            [27.062643, 53.887505],
            [27.069924, 53.886157],
            [27.072421, 53.88444],
            [27.074085, 53.881374],
            [27.073253, 53.877082],
            [27.072421, 53.874629],
            [27.072837, 53.871808],
            [27.072629, 53.868374],
            [27.072213, 53.864448],
            [27.076373, 53.858928],
            [27.083862, 53.855737],
            [27.09572, 53.853651],
            [27.101961, 53.85267],
            [27.108618, 53.852302],
            [27.114651, 53.850829],
            [27.1211, 53.849602],
            [27.128382, 53.850216],
            [27.133582, 53.852302],
            [27.137327, 53.854879],
            [27.139615, 53.856719],
            [27.143984, 53.859418],
            [27.147521, 53.861749],
            [27.152097, 53.862976],
            [27.160835, 53.861995],
            [27.163955, 53.858437],
            [27.165828, 53.855492],
            [27.167492, 53.853038],
            [27.171861, 53.851443],
            [27.174981, 53.850829],
            [27.179142, 53.851811],
            [27.183302, 53.853651],
            [27.187047, 53.855983],
            [27.189959, 53.858069],
            [27.195368, 53.860155],
            [27.198697, 53.860768],
            [27.20577, 53.859664],
            [27.211179, 53.857087],
            [27.22054, 53.855001],
            [27.226157, 53.853161],
            [27.232606, 53.851934],
            [27.238431, 53.851811],
            [27.248417, 53.850093],
            [27.252577, 53.848743],
            [27.255282, 53.847638],
            [27.261107, 53.845552],
            [27.26714, 53.844447],
            [27.269636, 53.84322],
            [27.270676, 53.838801],
            [27.26922, 53.834873],
            [27.265476, 53.830699],
            [27.264227, 53.828243],
            [27.266516, 53.825542],
            [27.269636, 53.824559],
            [27.279622, 53.823209],
            [27.281286, 53.82284],
            [27.285239, 53.82149],
            [27.285031, 53.81977],
            [27.285447, 53.814244],
            [27.285447, 53.811418],
            [27.287943, 53.80847],
            [27.292312, 53.804785],
            [27.295224, 53.803556],
            [27.302089, 53.802451],
            [27.307914, 53.802574],
            [27.314987, 53.803065],
            [27.321853, 53.802942],
            [27.325597, 53.801345],
            [27.326013, 53.798151],
            [27.326429, 53.793481],
            [27.324557, 53.788934],
            [27.325181, 53.785739],
            [27.328094, 53.784878],
            [27.334751, 53.784633],
            [27.339327, 53.785124],
            [27.345776, 53.785616],
            [27.350977, 53.787828],
            [27.355554, 53.790655],
            [27.359091, 53.795079],
            [27.362419, 53.797045],
            [27.369076, 53.798396],
            [27.376149, 53.798028],
            [27.382598, 53.794464],
            [27.38343, 53.79004],
            [27.37927, 53.785862],
            [27.372613, 53.784141],
            [27.368036, 53.783649],
            [27.364915, 53.78156],
            [27.363875, 53.779347],
            [27.365748, 53.774184],
            [27.3697, 53.771479],
            [27.378854, 53.770372],
            [27.387383, 53.77025],
            [27.39196, 53.769389],
            [27.404234, 53.766684],
            [27.411723, 53.764593],
            [27.418588, 53.761273],
            [27.423581, 53.757706],
            [27.425869, 53.753402],
            [27.424829, 53.749834],
            [27.422541, 53.747251],
            [27.418588, 53.74516],
            [27.418588, 53.743068],
            [27.419836, 53.740115],
            [27.423165, 53.736055],
            [27.425037, 53.73384],
            [27.428366, 53.729409],
            [27.42795, 53.726209],
            [27.425037, 53.723625],
            [27.419628, 53.721901],
            [27.414635, 53.720301],
            [27.409435, 53.718947],
            [27.405482, 53.715746],
            [27.404858, 53.712545],
            [27.407562, 53.709097],
            [27.411099, 53.704911],
            [27.4163, 53.702078],
            [27.420252, 53.700477],
            [27.426701, 53.699862],
            [27.43315, 53.699985],
            [27.440016, 53.700354],
            [27.446257, 53.700108],
            [27.450625, 53.698384],
            [27.451249, 53.695797],
            [27.450833, 53.692718],
            [27.452081, 53.690131],
            [27.456658, 53.68816],
            [27.461443, 53.688037],
            [27.467268, 53.688037],
            [27.473093, 53.687913],
            [27.477045, 53.685696],
            [27.47871, 53.682123],
            [27.478918, 53.677194],
            [27.480166, 53.672142],
            [27.481206, 53.66943],
            [27.482246, 53.665856],
            [27.484132, 53.660502],
            [27.485107, 53.657227],
            [27.486082, 53.653567],
            [27.487399, 53.651127],
          ],
          [
            [27.74477, 53.951388],
            [27.740564, 53.951489],
            [27.742195, 53.948156],
            [27.74374, 53.948459],
            [27.746229, 53.940578],
            [27.743311, 53.940275],
            [27.739449, 53.940376],
            [27.736702, 53.940932],
            [27.733612, 53.940326],
            [27.734556, 53.938153],
            [27.736187, 53.935879],
            [27.733011, 53.935071],
            [27.734041, 53.933201],
            [27.725801, 53.930422],
            [27.717991, 53.930169],
            [27.719879, 53.926783],
            [27.726316, 53.925419],
            [27.752838, 53.930826],
            [27.745028, 53.921729],
            [27.753696, 53.919303],
            [27.749319, 53.916371],
            [27.747688, 53.912933],
            [27.777386, 53.901355],
            [27.799015, 53.901203],
            [27.823305, 53.901355],
            [27.829313, 53.903934],
            [27.833262, 53.902315],
            [27.841759, 53.903428],
            [27.84193, 53.899736],
            [27.851372, 53.9009],
            [27.851028, 53.875202],
            [27.830429, 53.871356],
            [27.775497, 53.874595],
            [27.759361, 53.869737],
            [27.756957, 53.864473],
            [27.802275, 53.869737],
            [27.828368, 53.844628],
            [27.760048, 53.819706],
            [27.72357, 53.838601],
            [27.718549, 53.837082],
            [27.716017, 53.832194],
            [27.714171, 53.827306],
            [27.699967, 53.830168],
            [27.707005, 53.825001],
            [27.708721, 53.822037],
            [27.714429, 53.817756],
            [27.704129, 53.811877],
            [27.693915, 53.80539],
            [27.690396, 53.804529],
            [27.686276, 53.804681],
            [27.672458, 53.808203],
            [27.671556, 53.809825],
            [27.679796, 53.818718],
            [27.67632, 53.820137],
            [27.673101, 53.818465],
            [27.665505, 53.823202],
            [27.66881, 53.825229],
            [27.667608, 53.825963],
            [27.663574, 53.824621],
            [27.657008, 53.815463],
            [27.65542, 53.815881],
            [27.657051, 53.821429],
            [27.665291, 53.828724],
            [27.678337, 53.833385],
            [27.674646, 53.839361],
            [27.667995, 53.844071],
            [27.663403, 53.838905],
            [27.652244, 53.833486],
            [27.628555, 53.832473],
            [27.576971, 53.832118],
            [27.581005, 53.825178],
            [27.589331, 53.826191],
            [27.593966, 53.825584],
            [27.592678, 53.817933],
            [27.605553, 53.806987],
            [27.597141, 53.79548],
            [27.588987, 53.792489],
            [27.570276, 53.815298],
            [27.569246, 53.823962],
            [27.579031, 53.824824],
            [27.575083, 53.832068],
            [27.563667, 53.831764],
            [27.549849, 53.832777],
            [27.533884, 53.834702],
            [27.493887, 53.839234],
            [27.488523, 53.839716],
            [27.482514, 53.840247],
            [27.48054, 53.840349],
            [27.480455, 53.83964],
            [27.478395, 53.83693],
            [27.478094, 53.835968],
            [27.475562, 53.836778],
            [27.475004, 53.835436],
            [27.473159, 53.835613],
            [27.473588, 53.837285],
            [27.472687, 53.837462],
            [27.468438, 53.835487],
            [27.46685, 53.837589],
            [27.46316, 53.838196],
            [27.467537, 53.841995],
            [27.446251, 53.844223],
            [27.432861, 53.850906],
            [27.42857, 53.854855],
            [27.42548, 53.860323],
            [27.422047, 53.86832],
            [27.413464, 53.868219],
            [27.411061, 53.866801],
            [27.401104, 53.866801],
            [27.401791, 53.859614],
            [27.395955, 53.85931],
            [27.372094, 53.871862],
            [27.37999, 53.873077],
            [27.384968, 53.874595],
            [27.385656, 53.876922],
            [27.398529, 53.876619],
            [27.398702, 53.882083],
            [27.414666, 53.882994],
            [27.413292, 53.88522],
            [27.400246, 53.885018],
            [27.397671, 53.902922],
            [27.402134, 53.902619],
            [27.403336, 53.890177],
            [27.410374, 53.89129],
            [27.405911, 53.900293],
            [27.405739, 53.904642],
            [27.407456, 53.908585],
            [27.407627, 53.911821],
            [27.409687, 53.91536],
            [27.419472, 53.931231],
            [27.433205, 53.942852],
            [27.435179, 53.944721],
            [27.436895, 53.945175],
            [27.438269, 53.946388],
            [27.442217, 53.949621],
            [27.443762, 53.950732],
            [27.444277, 53.951591],
            [27.445221, 53.952247],
            [27.452431, 53.958914],
            [27.460671, 53.964367],
            [27.46994, 53.967801],
            [27.48024, 53.968608],
            [27.511139, 53.970022],
            [27.533541, 53.970527],
            [27.540407, 53.971082],
            [27.560062, 53.971032],
            [27.585211, 53.972344],
            [27.593965, 53.971436],
            [27.596712, 53.970577],
            [27.598257, 53.971486],
            [27.599545, 53.971436],
            [27.598772, 53.970123],
            [27.607527, 53.967599],
            [27.624178, 53.96159],
            [27.632504, 53.962044],
            [27.630015, 53.965478],
            [27.632589, 53.966589],
            [27.631044, 53.967952],
            [27.643232, 53.967346],
            [27.642975, 53.963357],
            [27.6401, 53.961994],
            [27.636323, 53.961439],
            [27.633963, 53.961262],
            [27.63216, 53.960807],
            [27.630444, 53.959419],
            [27.631216, 53.958636],
            [27.633147, 53.960302],
            [27.635679, 53.959217],
            [27.633576, 53.957904],
            [27.637739, 53.956389],
            [27.640228, 53.955682],
            [27.642632, 53.95476],
            [27.646151, 53.957954],
            [27.648039, 53.957209],
            [27.644799, 53.954027],
            [27.648468, 53.952651],
            [27.661343, 53.948004],
            [27.662287, 53.950025],
            [27.662458, 53.950833],
            [27.669926, 53.95356],
            [27.674561, 53.951489],
            [27.689324, 53.955429],
            [27.684174, 53.957045],
            [27.686062, 53.959722],
            [27.691641, 53.958813],
            [27.692156, 53.96159],
            [27.701683, 53.961237],
            [27.704945, 53.961287],
            [27.71018, 53.961338],
            [27.71842, 53.960681],
            [27.724514, 53.958661],
            [27.734556, 53.963155],
            [27.735758, 53.962044],
            [27.738333, 53.963812],
            [27.743568, 53.961742],
            [27.746143, 53.958358],
            [27.747345, 53.95457],
            [27.74477, 53.951388],
          ],
        ],
      },
      properties: {
        shapeName: "Minsk",
        shapeISO: "",
        shapeID: "67162791B84471344127718",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
